import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorksMeasures: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURES,
	},
	getDoneWorksMeasurePreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE_PREVIEW,
	},
	getDoneWorksMeasurePopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE_POPUP,
	},
	createDoneWorksMeasure: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].CREATE_DONE_WORKS_MEASURE,
	},
	getDoneWorksMeasure: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE,
	},
	patchDoneWorksMeasure: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PATCH_DONE_WORKS_MEASURE,
	},
	patchDoneWorksMeasureBulkUpdate: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PATCH_DONE_WORKS_MEASURE_BULK_UPDATE,
	},
	postDoneWorksMeasureBulkCreate: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].POST_DONE_WORKS_MEASURE_BULK_CREATE,
	},
	putDoneWorksMeasure: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PUT_DONE_WORKS_MEASURE,
	},
	deleteDoneWorksMeasure: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].DELETE_DONE_WORKS_MEASURE,
	},
}